import styled from '@emotion/styled'
import { SearchHighlight } from '@lune/common/search'
import { alpha, useTheme } from '@mui/material'
import Snackbar from '@mui/material/Snackbar'
import React, { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const AddressContainer = styled.address(() => {
  const theme = useTheme()
  return {
    cursor: 'pointer',
    color: `${alpha(theme.palette.text.primary, 0.75)}`
  }
})

interface AddressProps {
  value: string
  search: string
  showDomain?: boolean
}

interface AddressState {
  copiedText: boolean
}

export class Address extends Component<AddressProps, AddressState> {
  state = {
    copiedText: false
  }

  static defaultProps = {
    showDomain: true
  }

  constructor(props: AddressProps) {
    super(props)
    this.copyHandler = this.copyHandler.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  copyHandler = (): void => {
    this.setState({ copiedText: true })
  }

  onClose = (): void => {
    this.setState({ copiedText: false })
  }

  render = (): React.JSX.Element => {
    const { value, search, showDomain } = this.props
    const displayValue = showDomain ? value : value.split('@')[0]
    return (
      <>
        <CopyToClipboard text={value} onCopy={this.copyHandler}>
          <AddressContainer>
            <SearchHighlight text={displayValue} search={search} />
          </AddressContainer>
        </CopyToClipboard>
        <Snackbar
          open={this.state.copiedText}
          autoHideDuration={3000}
          onClose={this.onClose}
          message={`Copied ${value} to clipboard`}
        />
      </>
    )
  }
}
